
    import './styles.scoped.css';
    export default {
  "badge": "awsui_badge_1yjyg_cbpuf_94",
  "badge-color-grey": "awsui_badge-color-grey_1yjyg_cbpuf_112",
  "badge-color-green": "awsui_badge-color-green_1yjyg_cbpuf_115",
  "badge-color-blue": "awsui_badge-color-blue_1yjyg_cbpuf_118",
  "badge-color-red": "awsui_badge-color-red_1yjyg_cbpuf_121"
};
  